import { SUBSCRIBE_MODALS_SHOW_PRICING_MODAL } from './SubscriptionPlans/SubscribeModals/actions';

import {
  BLOCKPAGE_OPEN_SHARE_MODAL,
  SET_BLOCKPAGE_UI_MODE,
} from './BlockPageUI/actions';
import {
  CONTENT_EDITOR_DIAGRAM_CLICKED,
  CONTENT_EDITOR_WALKTHROUGH_CLICKED,
  CONTENT_EDITOR_SKIP_GUIDE_CLICKED,
} from '../web/containers/CourseContentEditor/actions';
import {
  STARTER_PAGE_CLOSE_MODAL,
  STARTER_PAGE_VIDEO_PLAY,
  STARTER_PAGE_VIDEO_PASS_TIMESTAMP,
  STARTER_PAGE_VIDEO_END,
} from '../web/containers/StarterPage/actions';
import {
  INSTITUTION_STUDENT_DATA_VIEWED,
  INSTITUTION_STUDENT_DATA_DOWNLOADED,
  CREATE_INSTITUTION_STUDENT_DATA_EXPORT_STARTED,
} from './InstitutionAdminUI/StudentData/actions';
import { METRICS_EVENT_MANUAL, METRICS_IDENTIFY } from './Metrics/actions';
import { onLogEvent, onIdentify } from './actionThunks/metrics';
import {
  ENTER_THANK_YOU_PAGE_DATA_LOAD_SUCCESS,
  SUBMIT_PAYMENT_START,
} from './PaymentTransaction/actions';
import {
  CERTIFICATE,
  COURSE_ENROLMENT,
  SUBSCRIPTION_PLAN,
} from './PaymentTransaction/constants';
import { ActionTypes as UserpilotActionTypes } from './Userpilot/actions';
import { ActionTypes as PageHelperActionTypes } from './PageHelper/actions';
import { PORTAL_TURNED_ONLINE } from './PortalAdmin/actions';
import { INSTITUTION_CREATE_PORTAL_SUCCESS } from './InstitutionAdmin/actions';

const actionTriggers = {
  [SUBSCRIBE_MODALS_SHOW_PRICING_MODAL]: ({
    options: {
      extra: { metrics },
    },
    dispatch,
  }) => {
    dispatch(metrics.logEvent('UpgradePrompt-Viewed'));
  },
  [SUBMIT_PAYMENT_START]: ({
    options: {
      extra: { metrics },
    },
    dispatch,
    action: { eventData },
  }) => {
    const { isTrialSubscriptionPurchase, ..._eventData } = eventData;

    if (isTrialSubscriptionPurchase) {
      dispatch(metrics.logEvent('StartTrialButton-Clicked', _eventData));
    }
  },
  [BLOCKPAGE_OPEN_SHARE_MODAL]: ({
    options: {
      extra: { metrics },
    },
    dispatch,
    action: { blockId },
    getState,
  }) => {
    const currentUserId = getState().Auth.get('currentUser');
    dispatch(
      metrics.logEvent('share-start', {
        page: blockId, // Twig: Anish, is this correct?
        'user-id': currentUserId,
      })
    );
  },
  [CONTENT_EDITOR_WALKTHROUGH_CLICKED]: ({
    options: {
      extra: { metrics },
    },
    dispatch,
    action: { eventData },
  }) => {
    dispatch(
      metrics.logEvent('ContentEditorWalkthrough-Clicked', eventData || {})
    );
  },
  [CONTENT_EDITOR_DIAGRAM_CLICKED]: ({
    options: {
      extra: { metrics },
    },
    dispatch,
    action: { eventData },
  }) => {
    dispatch(metrics.logEvent('ContentEditorDiagram-Clicked', eventData || {}));
  },
  [CONTENT_EDITOR_SKIP_GUIDE_CLICKED]: ({
    options: {
      extra: { metrics },
    },
    dispatch,
    action: { eventData },
  }) => {
    dispatch(
      metrics.logEvent('ContentEditorWalkthrough-Skip', eventData || {})
    );
  },
  [STARTER_PAGE_CLOSE_MODAL]: ({
    options: {
      extra: { metrics },
    },
    dispatch,
  }) => {
    dispatch(metrics.logEvent('EducatorOnBoardingVideo-Closed', {}));
  },
  [STARTER_PAGE_VIDEO_PLAY]: ({
    options: {
      extra: { metrics },
    },
    dispatch,
    action: { autoplay },
  }) => {
    dispatch(metrics.logEvent('EducatorOnBoardingVideo-Played', { autoplay }));
  },
  [STARTER_PAGE_VIDEO_PASS_TIMESTAMP]: ({
    options: {
      extra: { metrics },
    },
    dispatch,
    action: { timestamp },
  }) => {
    dispatch(
      metrics.logEvent('EducatorOnBoardingVideo-PassTimestamp', { timestamp })
    );
  },
  [STARTER_PAGE_VIDEO_END]: ({
    options: {
      extra: { metrics },
    },
    dispatch,
  }) => {
    dispatch(metrics.logEvent('EducatorOnBoardingVideo-Ended', {}));
  },
  [INSTITUTION_STUDENT_DATA_VIEWED]: ({
    options: {
      extra: { metrics },
    },
    dispatch,
    action: { institutionPath },
  }) => {
    dispatch(metrics.logEvent('Studentdata-Viewed', { institutionPath }));
  },
  [METRICS_EVENT_MANUAL]: onLogEvent,
  [METRICS_IDENTIFY]: onIdentify,
  [CREATE_INSTITUTION_STUDENT_DATA_EXPORT_STARTED]: ({
    options: {
      extra: { metrics },
    },
    dispatch,
    action: {
      institutionPath,
      coursePath,
      cohortPath,
      sortBy,
      includeEnrolmentQuestions,
    },
  }) => {
    dispatch(
      metrics.logEvent('Studentdata-Exported', {
        institutionPath,
        coursePath,
        cohortPath,
        sortBy,
        includeEnrolmentQuestions,
      })
    );
  },
  [INSTITUTION_STUDENT_DATA_DOWNLOADED]: ({
    options: {
      extra: { metrics },
    },
    dispatch,
    action: {
      institutionPath,
      coursePath,
      cohortPath,
      sortBy,
      includeEnrolmentQuestions,
    },
  }) => {
    dispatch(
      metrics.logEvent('Studentdata-Downloaded', {
        institutionPath,
        coursePath,
        cohortPath,
        sortBy,
        includeEnrolmentQuestions,
      })
    );
  },
  [ENTER_THANK_YOU_PAGE_DATA_LOAD_SUCCESS]: ({
    options: {
      extra: { metrics },
    },
    dispatch,
    action: { paymentTransaction },
  }) => {
    const { id, userID } = paymentTransaction;
    paymentTransaction.purchaseItems.forEach((purchaseItem) => {
      const { productID, priceAUD } = purchaseItem;
      const eventData = { productID, priceAUD, paymentID: id, userID };

      if (purchaseItem.type === CERTIFICATE) {
        dispatch(metrics.logEvent('GACertificate-Purchased', eventData));
      } else if (purchaseItem.type === COURSE_ENROLMENT) {
        dispatch(metrics.logEvent('GACourse-Purchased', eventData));
      } else if (purchaseItem.type === SUBSCRIPTION_PLAN) {
        dispatch(metrics.logEvent('GASubscription-Purchased', eventData));
      }
    });
  },
  [UserpilotActionTypes.USERPILOT_SCRIPT_LOADED]: ({
    options: {
      extra: { userpilot },
    },
    dispatch,
  }) => {
    dispatch(userpilot.identify());
  },
  [SET_BLOCKPAGE_UI_MODE]: ({
    options: {
      extra: { userpilot },
    },
    dispatch,
    action: { mode },
  }) => {
    switch (mode) {
      case 'view':
        dispatch(userpilot.track('CoursePageMode-View'));
        break;
      case 'edit':
        dispatch(userpilot.track('CoursePageMode-Edit'));
        break;

      default:
        break;
    }
  },
  [PageHelperActionTypes.PAGE_HELPER_RENDER_PREVIEW_TEMPLATE]: ({
    options: {
      extra: { metrics },
    },
    dispatch,
    action: { templateId, templateName },
  }) => {
    dispatch(
      metrics.logEvent('PageTemplate-Previewed', {
        templateId,
        templateName,
      })
    );
  },
  [PageHelperActionTypes.PAGE_HELPER_RENDER_USE_PAGE_TEMPLATE_DETAILS]: ({
    options: {
      extra: { metrics },
    },
    dispatch,
    action: { templateId, pageName },
  }) => {
    dispatch(
      metrics.logEvent('PageTemplate-Chosen', {
        templateId,
        templateName: pageName,
      })
    );
  },
  [PageHelperActionTypes.PAGE_HELPER_ADD_PAGE_WITH_TEMPLATE_START]: ({
    options: {
      extra: { metrics },
    },
    dispatch,
    action: { templateId, templateName },
  }) => {
    dispatch(
      metrics.logEvent('PageTemplate-Used', {
        templateId,
        templateName,
      })
    );
  },
  [INSTITUTION_CREATE_PORTAL_SUCCESS]: ({
    options: {
      extra: { metrics },
    },
    dispatch,
    action: { name, path },
  }) => {
    dispatch(
      metrics.logEvent('Institution-Created', {
        institution: {
          name,
          path,
        },
      })
    );
  },
  [PORTAL_TURNED_ONLINE]: ({
    options: {
      extra: { metrics },
    },
    dispatch,
    action: { name, path },
  }) => {
    dispatch(
      metrics.logEvent('Institution-TurnedOnline', {
        institution: {
          name,
          path,
        },
      })
    );
  },
};

export const actionTriggerRoutes = Object.keys(actionTriggers).reduce(
  (triggers, actionType) => ({
    ...triggers,
    [actionType]: {
      thunk: actionTriggers[actionType],
    },
  }),
  {}
);
